import { gql } from '@apollo/client'

const SEARCH_REFERRAL_SOURCES = gql`
  query SEARCH_REFERRAL_SOURCES($searchTerm: String, $companyId: ID, $leadLink: ID) {
    searchReferralSources(searchTerm: $searchTerm, companyId: $companyId, leadLink: $leadLink) {
      id
      name
      color
      forceSubtype
      forPatients
      forUsers
      showForPatients
    }
  }
`

export default SEARCH_REFERRAL_SOURCES
